export const TOKEN_LIFE_TIME = 1800

export const CHANGE_PORTRAIT_LINK = 'CHANGE_PORTRAIT_LINK'
export const GET_NEW_MESSAGE_NUM = 'GET_NEW_MESSAGE_NUM'
export const CHANGE_SHRINK = 'CHANGE_SHRINK'
export const CHANGE_STUDYID = 'CHANGE_STUDYID'
export const REFRESH_AUTH = 'REFRESH_AUTH'
